<div class="modal-header">
  <h4 class="modal-title pull-left"> Set up Authenticator </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <loader [loading]="loading"></loader>
  <crm-alert #alert></crm-alert>

  <div class="row" *ngIf="!loading">
    <div class="col-sm12">
       <ul>
         <li>Get the Authenticator App from the
           <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en" target="_blank">Google Play Store</a> or
          <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank">App Store</a></li>
         <li>Choose <b>Scan a QR code</b></li>
       </ul>
    </div>

    <div class="col-sm-12">
       <div class="image-wrapper">
         <img style="width: 300px; height: 300px;" [src]="image" />
       </div>
    </div>

    <div class="col-sm-12">
      <div class="formg-group">
        <label>Enter the 6-digit code you see in the app.</label>
        <input type="text" class="form-control rounded-0" maxlength="6" [(ngModel)]="code" numbersOnly
          placeholder="Enter code" />
      </div>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-rbv" (click)="onSubmit()">Verify</button>
</div>
